import React from 'react';
import { Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { set, get, cloneDeep } from 'lodash';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { customStyles, roundingOff, allowOnlyNumber, currency_symbols } from '../../../../../Components/helper';
import { colourPath } from '../../fieldPath';
import { usePurchaseOrderState } from '../../PurchaseOrderContext/index';
import useMultiSingleSizePackedUnits from '../../Hooks/useMultiSingleSizePackedUnits';
import useGrandTotal from '../../Hooks/useGrandTotal';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

export const MultiSingleSizePackedUnits = ({ data, parentIndex }) => {
  const { t } = useTranslation('common');
  const {
    purchaseOrderData: { sizesData, legLengths },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);
  const { calculateMultiSingleSizePack } = useMultiSingleSizePackedUnits();
  const { calculateGrandTotal } = useGrandTotal();
  const {
    purchaseOrderState: { selectedCurrency },
    setPurchaseOrderState,
    disableConditions,
    purchaseOrderState,
    fromPreview,
    isPublicPoPage,
    poAddEditAccess,
    poDeleteAccess,
    lengthEnabled,
  } = usePurchaseOrderState();
  const AddPath = 'COMMON_LABEL.ADD';
  const deletePath = 'COMMON_LABEL.DELETE';

  const onChange = async (value, keyValue, i, index) => {
    const copyState = purchaseOrderState;
    set(copyState, keyValue, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
    const multiSingleSizePackedUnitsPath = colourPath(parentIndex, i).MULTIPLE_SINGLE_SIZE_PACKED_UNITS.COMMON_PATH;
    const multiSizepackedUnits = get(copyState, multiSingleSizePackedUnitsPath);
    const obj = cloneDeep(await calculateMultiSingleSizePack(multiSizepackedUnits, index));
    set(copyState, multiSingleSizePackedUnitsPath, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(copyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addRow = async (element, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.multiplePackedRows.push(element);
    const obj = cloneDeep(await calculateMultiSingleSizePack(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteRow = async (i, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.multiplePackedRows.splice(i, 1);
    const obj = cloneDeep(await calculateMultiSingleSizePack(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addNewCard = async (element) => {
    const copyState = cloneDeep(data);
    const tempEle = element;
    tempEle.shipmentDate = null;
    tempEle.handOverDate = null;
    copyState.push(tempEle);
    const obj = cloneDeep(await calculateMultiSingleSizePack(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteExistingCard = async (i) => {
    const copyState = cloneDeep(data);
    copyState.splice(i, 1);
    const obj = cloneDeep(await calculateMultiSingleSizePack(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const changeHandOverDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.handOverDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const changeShipmentDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.shipmentDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].multiplePacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const hasDate = (element) => {
    return element ? new Date(element) : null;
  };

  return data?.map((ele, i) => {
    return (
      <Card key={i} className="card-margin-bottom rounded-0">
        <Card.Header className="bgcolor-dark rounded-0">
          <div className="d-flex  align-items-center p-2">
            <strong>{t('FILTER.MULTI_SINGLE_SIGE_PACKED')}</strong>
            <div className="date px-3 ml-auto">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.HANDOVER_DATE_DATE_MULTI')}
                  popperPlace="top-end"
                  keyProp={`handOverDate_${parentIndex}_${i}_MultiSingleSizepack`}
                  placeholder={t('FILTER.HANDOVER_DATE')}
                  disable
                  onChange={(e) => changeHandOverDate(e, i)}
                  valueProp={hasDate(data[i]?.handOverDate)}
                />
              </div>
            </div>
            <div className="date justify-content-end px-1">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.SHIPMENT_DATE_MULTI')}
                  popperPlace="top-end"
                  placeholder={t('FILTER.SHIPMENT_DATE')}
                  keyProp={`shipmentDate_${parentIndex}_${i}_MultiSingleSizepack`}
                  disable
                  onChange={(e) => changeShipmentDate(e, i)}
                  valueProp={hasDate(data[i]?.shipmentDate)}
                />
              </div>
            </div>
          </div>
        </Card.Header>
        {!fromPreview && !isPublicPoPage && (
          <div className="d-flex pt-2 justify-content-end">
            {data?.length === i + 1 && poAddEditAccess && (
              <button className="btn btn-outline" type="button" disabled onClick={() => addNewCard(ele)} title={t(AddPath)} aria-label={t(AddPath)}>
                <i className="icon-add" />
              </button>
            )}
            {data?.length !== 1 && poDeleteAccess && (
              <button
                className="btn btn-outline px-1"
                type="button"
                disabled
                onClick={() => deleteExistingCard(i)}
                title={t(deletePath)}
                aria-label={t(deletePath)}
              >
                <i className="icon-delete" />
              </button>
            )}
          </div>
        )}
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-5">
              <thead>
                <tr>
                  <th>{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                  {lengthEnabled && <th>{t('FILTER.LENGTH')}</th>}
                  <th>{t('FILTER.PACK_RATIO')}</th>
                  <th>{t('FILTER.TOTAL_PACKS')}</th>
                  <th>{t('FILTER.TOTAL_UNITS')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_RATIO')}</th>
                  <th>{t('FILTER.DISCOUNT_PER_UNIT')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_DISCOUNTS')}</th>
                  {!fromPreview && !isPublicPoPage && <th>{t('COSTING_TO_DO_LIST.ACTION')}</th>}
                </tr>
              </thead>
              <tbody>
                {ele?.multiplePackedRows?.map((element, index) => {
                  return (
                    ((fromPreview && isPublicPoPage && element?.size) || !fromPreview || !isPublicPoPage) && (
                      <tr key={index}>
                        <td>
                          <div className="custom-react-select">
                            <Select
                              name="Size"
                              options={sizesData}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.size || typeof element?.size === 'number' ? { name: element?.size } : null) || ''}
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              isDisabled
                              styles={customStyles}
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              onChange={(event) =>
                                onChange(event?.name, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.SIZE_PATH, i, index)
                              }
                              placeholder={t('FILTER.SELECT_SIZE')}
                            />
                          </div>
                        </td>
                        {lengthEnabled && (
                          <td>
                            <Select
                              name="Length"
                              options={legLengths}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.length ? element?.length : null) || ''}
                              styles={customStyles}
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              isDisabled
                              onChange={(event) =>
                                onChange({ name: event?.name }, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.LENGTH_PATH, i, index)
                              }
                              placeholder={t('FILTER.SELECT_LENGTH')}
                            />
                          </td>
                        )}
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Pack Ratio"
                            placeholder={t('FILTER.PACK_RATIO')}
                            className="form-control text-bordered"
                            value={element?.packRatio || ''}
                            disabled
                            onChange={(e) =>
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.PACK_RATIO, i, index)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Total Packs"
                            placeholder={t('FILTER.TOTAL_PACKS')}
                            className="form-control text-bordered"
                            value={element?.packsQuantity || ''}
                            disabled
                            onChange={(e) =>
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.PACK_QUANTITY, i, index)
                            }
                          />
                        </td>
                        <td>
                          <strong>{element?.totalUnits ? new Intl.NumberFormat().format(roundingOff(element?.totalUnits, 2)) : null}</strong>
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (Before Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_RATIO')}
                            className="form-control text-bordered"
                            value={element?.beforeDiscPrice || ''}
                            disabled
                            onChange={(e) =>
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.BEFORE_DESCOUNT, i, index)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Discount"
                            placeholder={t('PROGRESS_INDICATOR.DISCOUNT')}
                            className="form-control text-bordered"
                            value={element?.discount || ''}
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.DISCOUNT, i, index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (After Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_DISCOUNTS')}
                            className="form-control text-bordered"
                            value={(element?.afterDiscPrice ? roundingOff(element?.afterDiscPrice, 2) : null) || ''}
                            readOnly
                            disabled
                            onChange={(e) =>
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTIPLE_SINGLE_SIZE_PACKED_UNITS?.AFTER_DISCOUNT, i, index)
                            }
                          />
                        </td>
                        {!fromPreview && !isPublicPoPage && (
                          <td>
                            <div className="d-flex">
                              {poAddEditAccess && (
                                <button
                                  title={t(AddPath)}
                                  aria-label={t(AddPath)}
                                  disabled
                                  type="button"
                                  className="btn btn-outline"
                                  onClick={() => addRow(element, i)}
                                >
                                  <i className="icon-add" />
                                </button>
                              )}
                              {ele?.multiplePackedRows?.length !== 1 && poDeleteAccess && (
                                <button
                                  type="button"
                                  className="btn btn-outline px-1"
                                  disabled
                                  onClick={() => deleteRow(index, i)}
                                  title={t(deletePath)}
                                  aria-label={t(deletePath)}
                                >
                                  <i className="icon-delete" />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                <tr key={i}>
                  <td colSpan={9}>
                    <strong className="d-flex align-item-center justify-content-center">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalSize) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalSize ? new Intl.NumberFormat().format(roundingOff(ele?.totalSize, 2)) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalLength) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalLength ? new Intl.NumberFormat().format(roundingOff(ele?.totalLength, 2)) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalPackRatio) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalPackRatio ? new Intl.NumberFormat().format(roundingOff(ele?.totalPackRatio, 2)) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalPacks) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalPacks ? new Intl.NumberFormat().format(roundingOff(ele?.totalPacks, 2)) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalUnits) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalUnits ? new Intl.NumberFormat().format(roundingOff(ele?.totalUnits, 2)) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalPriceBeforeDisc) || !fromPreview || !isPublicPoPage) && ele?.totalPriceBeforeDisc && (
                      <strong>
                        <span className="px-1">
                          {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                        </span>
                        {new Intl.NumberFormat().format(roundingOff(ele?.totalPriceBeforeDisc, 2))}
                      </strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalDiscountPerUnit) || !fromPreview || !isPublicPoPage) &&
                      (ele?.totalDiscountPerUnit ? <strong>{new Intl.NumberFormat().format(roundingOff(ele?.totalDiscountPerUnit, 2))}</strong> : null)}
                  </td>
                  <td colSpan={2}>
                    {((fromPreview && isPublicPoPage && ele?.totalPriceAfterDisc) || !fromPreview || !isPublicPoPage) && ele?.totalPriceAfterDisc && (
                      <strong>
                        <span className="px-1">
                          {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                        </span>
                        {new Intl.NumberFormat().format(roundingOff(ele?.totalPriceAfterDisc, 2))}
                      </strong>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );
  });
};

export default MultiSingleSizePackedUnits;
